import { render } from "./TradingBotProjectView.vue?vue&type=template&id=442c9986&ts=true"
import script from "./TradingBotProjectView.vue?vue&type=script&lang=ts"
export * from "./TradingBotProjectView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__